import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AUTH_FACADE } from '@dges/modules/auth/domain';
import { AuthFacade } from './+state/auth.facade';

export function provideAuthNgrxStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AUTH_FACADE, useExisting: AuthFacade },
  ]);
}
